export default "__VITE_ASSET__CVs$gr6b__"